require('whatwg-fetch');
require('es6-promise').polyfill();
window.$ = require('jquery');
window.jQuery = require('jquery');
